//import { message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { layouts } from "../../../constants/layouts";
import BasicDataInstitution from "./basicDataInstitution";
import "../game.scss";
import Teams from "./teams";
import "react-simple-keyboard/build/css/index.css";
import InstitutionCategory from "./institutionCategory";
import InstitutionEmail from "./institutionEmail";
import Axios from "axios";
import Gamers from "./gamers";
import EndScreen from "./endScreen";
import Progressbar from "../progressbar";
import KeyboardReact from "react-simple-keyboard";
import helmet from "../../../static/helmet.png";
import "./institution.scss";
import Gdpr from "../gdpr";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedInstitutionRegister extends Component {
  nameForm = React.createRef();
  categoryForm = React.createRef();
  emailForm = React.createRef();
  teamForm = React.createRef();

  state = {
    current: 0,
    email: "",
    teamName: "",
    institutionId: null,
    categoryId: null,
    category: "",
    selectedCategory: {},
    name: "",
    selectedName: {},
    inputName: "",
    layout: "default",
    teamId: null,
    keyboardVisible: true,
    timeOutId: null,
  };

  componentDidMount = () => {
    this.createNewTimeOut();
  };

  createNewTimeOut = () => {
    if (this.state.timeOutId !== null) {
      clearTimeout(this.state.timeOutId);
    }
    const timeOutId = setTimeout(() => {
      this.props.history.push("/");
    }, 120000);
    this.setState({ timeOutId: timeOutId });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  next = () => {
    this.setState({ current: this.state.current + 1, inputName: "" });
    this.createNewTimeOut();
  };

  prev = () => {
    this.setState({ current: this.state.current - 1, inputName: "" });
    this.createNewTimeOut();
  };

  setIds = (institutionId, categoryId) => {
    this.setState({ institutionId: institutionId, categoryId: categoryId });
  };

  setTeamId = (teamId) => {
    this.setState({ teamId: teamId });
  };

  onChangeAll = (inputs) => {
    if (this.state.inputName === "name") {
      this.nameForm.current.setFieldsValue({ name: inputs });
      this.setState({ name: inputs });
    } else if (this.state.inputName === "category") {
      this.categoryForm.current.setFieldsValue({ category: inputs });
      this.setState({ category: inputs });
    } else if (this.state.inputName === "email") {
      this.emailForm.current.setFieldsValue({ email: inputs });
      this.setState({ email: inputs });
    } else if (this.state.inputName === "teamName") {
      this.teamForm.current.setFieldsValue({ teamName: inputs });
      this.setState({ teamName: inputs });
    }
  };

  setInputName = (event) => {
    this.setState({ inputName: event.target.id });
  };

  handleChangeName = (event, option) => {
    this.setState({
      name: event,
      selectedName: option,
      institutionId: option.key,
    });
  };

  handleChangeCategory = (event, option) => {
    this.setState({
      category: event,
      selectedCategory: option,
      categoryId: option.key,
    });
  };

  handleSelectInstitution = async (value, option) => {
    this.setState({ selectedName: option, institutionId: option.key });
  };
  handleSelectCategory = (value, option) => {
    this.setState({ selectedCategory: option, categoryId: option.key });
  };

  onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") {
      this.handleShift();
    }
  };

  handleShift = () => {
    const newLayoutName = this.state.layout === "default" ? "shift" : "default";
    this.setState({ layout: newLayoutName });
  };

  submitBasicData = async () => {
    let categoryId;
    let institutionId;
    if (
      this.state.selectedName === null ||
      Object.keys(this.state.selectedName).length === 0
    ) {
      //intézmény létrehozás
      await Axios.post("/1.0.0/game/institution", {
        name: this.state.name,
      }).then((response) => {
        institutionId = response.data.id;
      });
    } else {
      institutionId = parseInt(this.state.selectedName.key);
    }
    if (
      this.state.selectedCategory === null ||
      Object.keys(this.state.selectedCategory).length === 0
    ) {
      await Axios.post("/1.0.0/game/category", {
        name: this.state.category,
        institutionId: institutionId,
      }).then((response) => {
        categoryId = response.data.id;
      });
    } else {
      categoryId = parseInt(this.state.selectedCategory.key);
    }
    this.setState({ categoryId: categoryId, institutionId: institutionId });
  };

  handleBackToTeamCreation = () => {
    this.setState({ current: 3 });
  };

  openKeyboard = () => {
    this.setState({ keyboardVisible: true });
  };

  closeKeyboard = () => {
    this.setState({ keyboardVisible: false });
  };

  render() {
    const steps = [
      {
        id: 0,
        title: "GDPR",
        description: "",
        ending: false,
        content: <Gdpr next={this.next} closeKeyboard={this.closeKeyboard} />,
      },
      {
        id: 1,
        title: "Intézmény",
        description: "",
        ending: false,
        content: (
          <BasicDataInstitution
            formRef={this.nameForm}
            changeName={this.handleChangeName}
            selectName={this.handleSelectInstitution}
            name={this.state.name}
            selectedCategory={this.state.selectedName}
            next={this.next}
            /* change={this.handleChange}
            email={this.state.email} */
            setIds={this.setIds}
            setInputName={this.setInputName}
            openKeyboard={this.openKeyboard}
          />
        ),
      },
      {
        id: 2,
        title: "Kategória",
        description: "",
        ending: false,
        content: (
          <InstitutionCategory
            formRef={this.categoryForm}
            changeCategory={this.handleChangeCategory}
            selectCategory={this.handleSelectCategory}
            institutionId={this.state.institutionId}
            category={this.state.category}
            selectedCategory={this.state.selectedCategory}
            next={this.next}
            prev={this.prev}
            change={this.handleChange}
            email={this.state.email}
            setIds={this.setIds}
            setInputName={this.setInputName}
          />
        ),
      },
      {
        id: 3,
        title: "Kapcsolattartó",
        description: "",
        ending: false,
        content: (
          <InstitutionEmail
            formRef={this.emailForm}
            next={this.next}
            prev={this.prev}
            change={this.handleChange}
            email={this.state.email}
            setIds={this.setIds}
            setInputName={this.setInputName}
            submit={this.submitBasicData}
          />
        ),
      },
      {
        id: 4,
        title: "Csapat",
        description: "",
        ending: false,
        content: (
          <Teams
            formRef={this.teamForm}
            next={this.next}
            prev={this.prev}
            teamName={this.state.teamName}
            change={this.handleChange}
            institutionId={this.state.institutionId}
            categoryId={this.state.categoryId}
            history={this.props.history}
            setInputName={this.setInputName}
            setTeamId={this.setTeamId}
            openKeyboard={this.openKeyboard}
          />
        ),
      },
      {
        id: 5,
        title: "Csapattagok",
        description: "",
        ending: false,
        content: (
          <Gamers
            formRef={this.teamForm}
            next={this.next}
            prev={this.prev}
            teamName={this.state.teamName}
            /* change={this.handleChange}
            institutionId={this.state.institutionId}
            categoryId={this.state.categoryId} */
            history={this.props.history}
            setInputName={this.setInputName}
            setTeamId={this.setTeamId}
            teamId={this.state.teamId}
            closeKeyboard={this.closeKeyboard}
          />
        ),
      },
      {
        id: 6,
        title: "",
        description: "",
        ending: true,
        content: (
          <EndScreen
            backToTeam={this.handleBackToTeamCreation}
            history={this.props.history}
          />
        ),
      },
    ];
    return (
      <div>
        {/* <div style={{ textAlign: "center" }}>
          <h2>Intézményi regisztráció</h2>
        </div>
        <div>
          <div style={{ textAlign: "center" }}>
            {steps[this.state.current].title}
          </div>
          <div className="steps-content">
            {steps[this.state.current].content}
          </div>
          
          {this.state.keyboardVisible && (
            <Keyboard
              layout={layouts}
              layoutName={this.state.layout}
              onChange={(inputs) => this.onChangeAll(inputs)}
              keyboardRef={(r) => (this.keyboard = r)}
              inputName={this.state.inputName}
              onKeyPress={this.onKeyPress}
            />
          )}
        </div> */}
        <div>
          <div
            style={{
              padding: "1.5em",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div style={{ display: "flex" }}>
                <div>
                  <img
                    alt="helmet"
                    src={helmet}
                    style={{ height: "70", width: "86px" }}
                  />
                </div>
                <h1 className="register-title">
                  {steps[this.state.current].title}
                </h1>
              </div>
              <p className="register-subtitle">
                {steps[this.state.current].description}
              </p>
            </div>
            <div>
              <Progressbar
                steps={steps}
                current={this.state.current}
                history={this.props.history}
              />
            </div>
          </div>
          <div /* className="steps-content" */>
            {steps[this.state.current].content}
          </div>
          {this.state.keyboardVisible && (
            <div style={{ position: "fixed", bottom: "0", width: "100%" }}>
              <KeyboardReact
                layout={layouts}
                layoutName={this.state.layout}
                onChange={(inputs) => this.onChangeAll(inputs)}
                keyboardRef={(r) => (this.keyboard = r)}
                inputName={this.state.inputName}
                onKeyPress={this.onKeyPress}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const InstitutionRegister = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedInstitutionRegister);
export default InstitutionRegister;
